module.exports = __webpack_public_path__ + "static/media/headerdelete-icon.942a614c.svg";